const meta_data = {
    "meta.title.home": "1-DAY ACUVUE® DEFINE®",
    "meta.desc.home": "คอนแทคเลนส์ชนิดรายวัน ผลิตจากนวัตกรรมวิทยาศาสตร์และศิลปะ เพื่อความงามและความสบายแก่ดวงตาคุณ",
    "meta.title.vm": "ลองเลนส์ ACUVUE® Define® เสมือนจริง",
    "meta.desc.vm": "ค้นหา 1-DAY ACUVUE® Define® ที่ใช่ที่สุดสำหรับคุณ",
    "meta.title.discover": "ส่องเลนส์ ACUVUE® DEFINE® ทั้งหมด",
    "meta.desc.discover": "เนรมิตความงาม ด้วยสีสันที่อินสไปร์จากธรรมชาติ",
    "meta.title.classic": "ส่องเลนส์ ACUVUE® DEFINE® Classic",
    "meta.desc.classic": "1-DAY ACUVUE® DEFINE® เฉดสีเนเชอรัลสุดคลาสสิก พร้อมเนรมิตให้ดวงตาโดดเด่น",
    "meta.title.fresh": "ส่องเลนส์ ACUVUE® DEFINE® Fresh",
    "meta.desc.fresh": "1-DAY ACUVUE® DEFINE® FRESH เติมความสดใสให้ดวงตาคุณ ด้วยเฉดสีที่อินสไปร์จากธรรมชาติ",
}

export default meta_data;